import React from 'react';
import styles from './index.module.scss';

function OfferTerms({ data }) {
  if (!data) {
    console.log('Terms and conditions data is not available');
    return;
  }

  const formattedTnc = data.split('\n').map((term) => term.trim());

  return (
    <div className={styles.termsPopup}>
      <div className={styles.termsPopupMain}>
        {formattedTnc.map((term, index) => (
          <p
            className={term.length > 200 ? styles.handleHtrTxt : ''}
            key={index}
          >
            {term}
          </p>
        ))}
      </div>
    </div>
  );
}

export default OfferTerms;
